import React from "react";
import {
  TeamCompleteProjectsIcon,
  TeamHappyCustumersIcon,
  TeamExpertEmployeesIcon,
} from "../common/Icons";
import { TeamData } from "../common/Content";
import TeamCards from "./TeamCards";
const Team = () => {
  return (
    <div className="open_overlay_sections_none">
      <section className="pt-4 pt-sm-5">
        <div className="container">
          <div className="row justify-content-lg-between">
            <div className="col-12 col-sm-6 col-lg-4 text-center text-lg-start">
              <h3 className="main_heading text-black">
                We are proud of
                <span className="d-xl-block">our creative team</span>
              </h3>
              <p className="main_para">
                Just sit back and relax while we take care
                <span className="d-xl-block">of your business needs.</span>
              </p>
            </div>
            <div className="col-12 col-sm-6 col-lg-2 text-center mt-4 mt-sm-0">
              <div>
                <span>
                  <TeamCompleteProjectsIcon />
                </span>
              </div>
              <h3 className="main_heading text-black mb-0 mt-3">434</h3>
              <p className="font-lg fw-normal">Complete Projects</p>
            </div>
            <div className="col-12 col-sm-6 col-lg-2 text-center mt-4 mt-lg-0">
              <div>
                <span>
                  <TeamHappyCustumersIcon />
                </span>
              </div>
              <h3 className="main_heading text-black mb-0 mt-3">3532</h3>
              <p className="font-lg fw-normal">Happy Custumers</p>
            </div>
            <div className="col-12 col-sm-6 col-lg-2 text-center mt-4 mt-lg-0">
              <div>
                <span>
                  <TeamExpertEmployeesIcon />
                </span>
              </div>
              <h3 className="main_heading text-black mb-0 mt-3">241</h3>
              <p className="font-lg fw-normal">Expert Employees</p>
            </div>
          </div>
          <TeamCards />
          {/* <div className="row">
            {TeamData &&
              TeamData.map((items, index) => {
                return (
                  <div
                    className="col-sm-6 col-lg-3 mt-4 mt-lg-5 team_members"
                    data-aos="zoom-in-up"
                    data-aos-duration="1500"
                    key={index}
                  >
                    <div className="team_bg text-center">
                      <img className="team_img w-100" src={items.img} alt="" />
                      <h4 className="font-lg fw-semibold mt-4 ms-3">
                        {items.heading}
                      </h4>
                      <p className="main_para ms-3 pb-3">{items.text}</p>
                    </div>
                  </div>
                );
              })}
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default Team;
